module.exports = __webpack_public_path__ + "static/media/img-4New.0a1556f9.jpg";